import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ?? '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface DJProfile {
  id: string;
  name: string;
  bio: string;
  profile_image: string;
  logo_url: string;
  instagram: string;
  facebook: string;
  twitter: string;
  youtube: string;
  spotify: string;
  soundcloud: string;
  location: string;
  phone: string;
  email: string;
  tiktok: string;
  admin_password: string;
  // Visibility toggles
  instagram_visible?: boolean;
  facebook_visible?: boolean;
  twitter_visible?: boolean;
  youtube_visible?: boolean;
  spotify_visible?: boolean;
  soundcloud_visible?: boolean;
  tiktok_visible?: boolean;
  // Section texts
  section_past_events_title?: string;
  section_past_events_subtitle?: string;
  section_past_events_description?: string;
  section_gallery_title?: string;
  section_gallery_subtitle?: string;
  section_gallery_description?: string;
  section_music_title?: string;
  section_music_description?: string;
  section_upcoming_title?: string;
  section_upcoming_subtitle?: string;
  section_upcoming_description?: string;
  section_social_title?: string;
  section_social_description?: string;
  section_contact_title?: string;
  section_contact_description?: string;
  section_footer_bio?: string;
  contact_form_url?: string;
  contact_form_email?: string;
}

export interface PastEvent {
  id: string;
  title: string;
  description: string;
  event_date: string;
  location: string;
  image_url: string;
}

export interface UpcomingEvent {
  id: string;
  title: string;
  description: string;
  event_date: string;
  event_time: string;
  location: string;
  venue: string;
  ticket_url: string | null;
  image_url: string | null;
}

export interface GalleryItem {
  id: string;
  type: 'photo' | 'video';
  url: string;
  thumbnail_url: string | null;
  title: string;
  created_at: string;
}

export interface Availability {
  id: string;
  date: string;
  status: 'available' | 'busy' | 'tentative';
  note?: string;
  created_at: string;
}

export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  event_type: string | null;
  message: string;
  is_read: boolean;
  created_at: string;
}
